import { call, put, takeLatest } from "redux-saga/effects";
import { notification } from "antd";
import { GET, POST } from "../../api";
import ApiRouts from "../../api/routes";
import { FETCH_PROFILE } from "../actions";
import { setProfile } from "./action";

function* fetchProfileSaga() {
    try {
        const response = yield call(GET, `${ApiRouts.API_GET_PROFILE}`, );
        if (response) {
            yield put(setProfile(response.data.data));
        } else {
            throw new Error("Failed to fetch the banner.");
        }
    } catch (error) {
    }
}

function* profileSaga() {
    yield takeLatest(FETCH_PROFILE, fetchProfileSaga);
}


export default profileSaga;
